import type { TBoard } from '../types';

export function checkDraw(board: TBoard): boolean {
  return board[0].every((cell) => cell !== null);
}
